<template>
    <div>
        <h1>{{ sluzba.name }}</h1>
    </div>
</template>

<script>
    export default {
        props: {
            sluzba: {
                type: Object,
                // default: {
                //     title: ""
                // }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>